export const DELAY = process.env.NODE_ENV === 'test' ? 0 : 500;
